import React, { useState, useEffect } from 'react';
import './attestationvalidation.css';
import './procesVerbal.css';
import app from './firebase.js';
import { getDatabase, ref, set, onValue, remove } from 'firebase/database';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import { Delete, Download, Eye, Edit, Plus } from 'react-feather';
import { Modal, Button, ConfigProvider, Popconfirm, message } from 'antd';
import logo from './img/edaplogo.png';
import unilislogo from './img/unilislogo.png';
import crlogo from './img/crlogo.png';
import virgilSig from './img/Virgil_sig.png';
import papaSig from './img/papa_sig.png';
import perezSig from './img/perez.png';
import rectorSig from './img/rector.png';
import bapSig from './img/bap_sig.png';

const TITLE_OPTIONS = [
    { value: 'DE DOCTORAT', label: 'DE DOCTORAT' },
    { value: 'DE MÉMOIRE DE HDR', label: 'MÉMOIRE DE HDR' },
    { value: 'DE MASTER', label: 'Master' },
    { value: 'DE LICENCE', label: 'Licence' },
];

/* Default jury members for testing – clear later */
const DEFAULT_JURY_MEMBERS_RAPPORT = [
    { role: 'Président', name: 'Pr Nizeyimana Jean Baptiste, Professeur en informatique, Université de Lisala-RDC' },
    { role: 'Directeur', name: 'Pr Ahmed KORA, Ecole Supérieure Multinationale des Télécommunications-Senegal' },
    { role: 'Co-Directeur', name: 'Pr Guy Juanole , Professeur de protocoles des réseaux informatiques, UNCR University-USA' },
    { role: 'Rapporteur', name: 'Pr Reem Bahgat, Professeur en informatique, Université de Lisala-RDC' },
    { role: 'Membre', name: 'Pr Martin Kersten' },
    { role: 'Membre', name: 'Pr Vaidyeswaran Rajaraman' },
];

const MENTION_OPTIONS = [
    { value: 'Très Honorable avec félicitations du jury', label: 'Très Honorable avec félicitations du jury' },
    { value: 'Très Honorable', label: 'Très Honorable' },
    { value: 'Honorable', label: 'Honorable' },
    { value: 'Bien', label: 'Bien' },
    { value: 'Assez Bien', label: 'Assez Bien' },
];

const getInitialFormData = () => ({
    titleType: '',
    genre: '',
    candidateName: '',
    dateNaissance: '',
    lieuNaissance: '',
    paysNaissance: '',
    numeroInscription: '',
    domaine: '',
    specialite: '',
    dateSoutenance: '',
    universite: '',
    typeTravail: '',
    juryMembers: DEFAULT_JURY_MEMBERS_RAPPORT.map((m) => ({ ...m })),
    sujetTravail: '',
    mention: '',
    lieuFait: '',
    dateFait: '',
});

const formatDateWithMonthName = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const formatDateShort = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

const formatDateWithMonthNameEnglish = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const RapportSoutenance = () => {
    const [formData, setFormData] = useState(() => ({
        ...getInitialFormData(),
        dateSoutenance: new Date().toISOString().split('T')[0],
        dateFait: new Date().toISOString().split('T')[0],
    }));
    const [documents, setDocuments] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [qrCodeData, setQrCodeData] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const db = getDatabase(app);

    useEffect(() => {
        onValue(ref(db, 'rapportSoutenance/UNCR/'), (snapshot) => {
            const data = snapshot.val();
            setDocuments(data ? Object.keys(data).map((key) => ({ id: key, ...data[key] })).sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)) : []);
        });
    }, [db]);

    useEffect(() => {
        if (!selectedDocument) return;
        let qrData = `RAPPORT SOUTENANCE - UNILIS/UNCR\n`;
        Object.keys(selectedDocument).forEach((key) => {
            if (key !== 'createdAt' && selectedDocument[key]) qrData += `${key}: ${selectedDocument[key]}\n`;
        });
        qrData += `Status: Document Verified\nIssued by: UNILIS - Université de Lisala`;
        QRCode.toDataURL(qrData, { width: 256, margin: 2, errorCorrectionLevel: 'M', color: { dark: '#000000', light: '#FFFFFF' } })
            .then(setQrCodeData)
            .catch(() => setQrCodeData(null));
    }, [selectedDocument]);

    useEffect(() => {
        const h = (e) => { if (e.key === 'Escape' && modalVisible) handleModalClose(); };
        document.addEventListener('keydown', h);
        return () => document.removeEventListener('keydown', h);
    }, [modalVisible]);

    const handleInputChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const normalizeJuryMembers = (doc) => {
        if (doc.juryMembers && Array.isArray(doc.juryMembers) && doc.juryMembers.length > 0) return doc.juryMembers;
        return [
            { role: 'Président', name: doc.juryPresident || '' },
            { role: 'Directeur', name: doc.juryDirecteur || '' },
            { role: 'Rapporteur', name: doc.juryRapporteur || '' },
            { role: 'Membre', name: doc.juryMembre1 || '' },
            { role: 'Membre', name: doc.juryMembre2 || '' },
        ];
    };

    const addJuryMember = () => setFormData((prev) => ({ ...prev, juryMembers: [...(prev.juryMembers || []), { role: 'Membre', name: '' }] }));

    const updateJuryMember = (index, name) => setFormData((prev) => {
        const juryMembers = [...(prev.juryMembers || DEFAULT_JURY_MEMBERS_RAPPORT.map((m) => ({ ...m })))];
        if (juryMembers[index]) juryMembers[index] = { ...juryMembers[index], name };
        return { ...prev, juryMembers };
    });

    const resetForm = () => {
        setFormData({ ...getInitialFormData(), dateSoutenance: new Date().toISOString().split('T')[0], dateFait: new Date().toISOString().split('T')[0] });
        setIsEditing(false);
        setEditingId(null);
    };

    const handleEditDocument = (doc) => {
        setFormData({
            ...getInitialFormData(),
            ...doc,
            juryMembers: normalizeJuryMembers(doc),
            dateSoutenance: doc.dateSoutenance || new Date().toISOString().split('T')[0],
            dateFait: doc.dateFait || new Date().toISOString().split('T')[0],
        });
        setIsEditing(true);
        setEditingId(doc.id);
        handleModalClose();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.candidateName?.trim() || !formData.numeroInscription?.trim()) {
            message.warning('Nom du candidat et numéro d\'inscription sont obligatoires.');
            return;
        }
        const id = (formData.numeroInscription || '').replace(/\s+/g, '_') || `rapport_${Date.now()}`;
        const pathId = isEditing && editingId ? editingId : id;
        const payload = { ...formData, createdAt: isEditing && editingId ? (documents.find((d) => d.id === editingId)?.createdAt || new Date().toISOString()) : new Date().toISOString() };
        set(ref(db, `rapportSoutenance/UNCR/${pathId}`), payload)
            .then(() => { message.success(isEditing ? 'Rapport modifié.' : 'Rapport enregistré.'); resetForm(); })
            .catch((err) => { console.error(err); message.error('Erreur lors de l\'enregistrement.'); });
    };

    const handleModalClose = () => { setModalVisible(false); setSelectedDocument(null); };
    const showModal = (doc) => { setSelectedDocument(doc); setModalVisible(true); };

    const handleDelete = (id) => {
        remove(ref(db, `rapportSoutenance/UNCR/${id}`)).then(() => message.success('Document supprimé.')).catch(() => message.error('Erreur lors de la suppression.'));
    };

    const downloadPDF = async (doc) => {
        const frenchEl = document.getElementById(`rapport-soutenance-${doc.id}-french`);
        const englishEl = document.getElementById(`rapport-soutenance-${doc.id}-english`);
        if (!frenchEl) return;
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const renderPage = async (el) => {
            const clone = el.cloneNode(true);
            clone.style.width = '21cm';
            clone.style.minHeight = '29.7cm';
            clone.style.margin = '0';
            clone.style.padding = '1.4cm 0.8cm';
            clone.style.background = 'white';
            clone.style.fontFamily = "'Times New Roman', serif";
            clone.style.boxSizing = 'border-box';
            const tmp = document.createElement('div');
            tmp.style.cssText = 'position: fixed; top: -9999px; left: -9999px; z-index: -1; width: 21cm;';
            tmp.appendChild(clone);
            document.body.appendChild(tmp);
            await Promise.all(Array.from(clone.querySelectorAll('img')).map((img) => new Promise((res) => { img.complete ? res() : (img.onload = img.onerror = res); })));
            await new Promise((r) => setTimeout(r, 300));
            const canvas = await html2canvas(clone, { scale: 2, useCORS: true, backgroundColor: '#FFFFFF', windowWidth: clone.scrollWidth, windowHeight: clone.scrollHeight });
            document.body.removeChild(tmp);
            const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
            const w = canvas.width * ratio;
            const h = canvas.height * ratio;
            return { img: canvas.toDataURL('image/png'), w, h, x: (pageWidth - w) / 2, y: (pageHeight - h) / 2 };
        };
        try {
            const p1 = await renderPage(frenchEl);
            pdf.addImage(p1.img, 'PNG', p1.x, p1.y, p1.w, p1.h);
            if (englishEl) {
                const p2 = await renderPage(englishEl);
                pdf.addPage();
                pdf.addImage(p2.img, 'PNG', p2.x, p2.y, p2.w, p2.h);
            }
            pdf.save(`Rapport_Soutenance_${(doc.candidateName || doc.id).replace(/\s+/g, '_')}.pdf`);
        } catch (err) {
            console.error(err);
            message.error('Erreur lors de la génération du PDF');
        }
    };

    return (
        <div className="UNCR proces-verbal-page">
            <div className="pv-form-container">
                <div className="pv-form-header">
                    <img src={logo} alt="Logo" className="pv-form-logo" />
                    <h2>Rapport de Soutenance – Thèse / Mémoire HDR</h2>
                </div>
                <form onSubmit={handleSubmit} className="pv-form">
                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Type (titre)</label>
                            <select name="titleType" value={formData.titleType} onChange={handleInputChange} required>
                                <option value="">—</option>
                                {TITLE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                        </div>
                        <div className="pv-form-group">
                            <label>Genre</label>
                            <select name="genre" value={formData.genre} onChange={handleInputChange}>
                                <option value="">—</option>
                                <option value="Monsieur">Monsieur</option>
                                <option value="Madame">Madame</option>
                            </select>
                        </div>
                    </div>
                    <div className="pv-form-group">
                        <label>Nom complet du candidat</label>
                        <input type="text" name="candidateName" value={formData.candidateName} onChange={handleInputChange} placeholder="Nom du candidat" required />
                    </div>
                    <div className="pv-form-row three-cols">
                        <div className="pv-form-group">
                            <label>Date de naissance</label>
                            <input type="date" name="dateNaissance" value={formData.dateNaissance} onChange={handleInputChange} />
                        </div>
                        <div className="pv-form-group">
                            <label>Lieu de naissance</label>
                            <input type="text" name="lieuNaissance" value={formData.lieuNaissance} onChange={handleInputChange} placeholder="Lieu" />
                        </div>
                        <div className="pv-form-group">
                            <label>Pays de naissance</label>
                            <input type="text" name="paysNaissance" value={formData.paysNaissance} onChange={handleInputChange} placeholder="Pays" />
                        </div>
                    </div>
                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Numéro d'inscription</label>
                            <input type="text" name="numeroInscription" value={formData.numeroInscription} onChange={handleInputChange} placeholder="Numéro" required />
                        </div>
                        <div className="pv-form-group">
                            <label>Domaine</label>
                            <input type="text" name="domaine" value={formData.domaine} onChange={handleInputChange} placeholder="Domaine" />
                        </div>
                        <div className="pv-form-group">
                            <label>Spécialité</label>
                            <input type="text" name="specialite" value={formData.specialite} onChange={handleInputChange} placeholder="Spécialité" />
                        </div>
                    </div>
                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Date de soutenance</label>
                            <input type="date" name="dateSoutenance" value={formData.dateSoutenance} onChange={handleInputChange} required />
                        </div>
                        <div className="pv-form-group flex2">
                            <label>Université</label>
                            <input type="text" name="universite" value={formData.universite} onChange={handleInputChange} placeholder="Université de soutenance" />
                        </div>
                    </div>
                    <div className="pv-form-group">
                        <label>Sa thèse / son Mémoire</label>
                        <select name="typeTravail" value={formData.typeTravail} onChange={handleInputChange}>
                            <option value="">—</option>
                            <option value="sa thèse">sa thèse</option>
                            <option value="son Mémoire">son Mémoire</option>
                        </select>
                    </div>
                    <div className="pv-form-section-label">Jury</div>
                    {(formData.juryMembers || DEFAULT_JURY_MEMBERS_RAPPORT.map((m) => ({ ...m }))).map((member, index) => (
                        <div key={index} className="pv-form-group">
                            <label>{member.role}</label>
                            <input
                                type="text"
                                value={member.name || ''}
                                onChange={(e) => updateJuryMember(index, e.target.value)}
                                placeholder="Nom, titre, affiliation"
                            />
                        </div>
                    ))}
                    <button type="button" className="pv-add-member-btn" onClick={addJuryMember}><Plus size={18} /> Ajouter un membre</button>
                    <div className="pv-form-group">
                        <label>Sujet du travail</label>
                        <textarea name="sujetTravail" value={formData.sujetTravail} onChange={handleInputChange} placeholder="Sujet de la thèse / mémoire" rows={3} />
                    </div>
                    <div className="pv-form-group">
                        <label>Mention</label>
                        <select name="mention" value={formData.mention} onChange={handleInputChange}>
                            <option value="">—</option>
                            {MENTION_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                        </select>
                    </div>
                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Fait à (lieu)</label>
                            <input type="text" name="lieuFait" value={formData.lieuFait} onChange={handleInputChange} placeholder="Lieu" />
                        </div>
                        <div className="pv-form-group">
                            <label>Date (Fait à)</label>
                            <input type="date" name="dateFait" value={formData.dateFait} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className="pv-form-group full-width">
                        <button type="submit" className="pv-submit-btn">{isEditing ? 'Modifier le rapport' : 'Enregistrer le rapport'}</button>
                        {isEditing && <button type="button" onClick={resetForm} className="pv-submit-btn" style={{ marginTop: '10px', background: 'linear-gradient(135deg, #6c757d, #5a6268)' }}>Annuler</button>}
                    </div>
                </form>
                <div className="pv-search-bar">
                    <input type="text" placeholder="Rechercher par nom ou numéro…" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                </div>
                <div className="pv-document-list">
                    {documents
                        .filter((d) => (d.candidateName || '').toLowerCase().includes(searchQuery.toLowerCase()) || (d.numeroInscription || '').toLowerCase().includes(searchQuery.toLowerCase()))
                        .map((doc) => (
                            <div key={doc.id} className="pv-document-item">
                                <button type="button" className="pv-view-btn" onClick={() => showModal(doc)}><Eye size={16} /> {doc.candidateName || doc.id} – {doc.numeroInscription}</button>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <button type="button" className="pv-edit-btn" onClick={() => handleEditDocument(doc)} title="Modifier"><Edit size={15} /></button>
                                    <Popconfirm title="Supprimer le document" description="Êtes-vous sûr ?" onConfirm={() => handleDelete(doc.id)} okText="Oui" cancelText="Non" okButtonProps={{ danger: true }}>
                                        <button type="button" className="pv-delete-btn" aria-label="Supprimer"><Delete size={15} /></button>
                                    </Popconfirm>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            <ConfigProvider>
                <Modal title={<span style={{ color: 'white' }}>Rapport de soutenance – {selectedDocument?.candidateName || ''}</span>} open={modalVisible} onCancel={handleModalClose} width="95vw" style={{ top: 10 }} className="pv-modal"
                    footer={[<Button key="download" type="primary" icon={<Download size={16} />} onClick={() => selectedDocument && downloadPDF(selectedDocument)} style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}>Télécharger PDF</Button>, <Button key="close" onClick={handleModalClose}>Fermer</Button>]}>
                    {selectedDocument && (
                        <div className="pv-modal-content pv-two-pages">
                            <RapportSoutenanceDocument formData={selectedDocument} id={selectedDocument.id} qrCodeData={qrCodeData} lang="french" />
                            <RapportSoutenanceDocument formData={selectedDocument} id={selectedDocument.id} qrCodeData={qrCodeData} lang="english" />
                        </div>
                    )}
                </Modal>
            </ConfigProvider>
        </div>
    );
};

const TITLE_EN = {
    'DE DOCTORAT': 'PhD DEGREE',
    'DE MÉMOIRE DE HDR': 'HDR MEMOIR',
    'MÉMOIRE DE HDR': 'HDR MEMOIR',
    'DE MASTER': 'Master\'s Degree',
    'MASTER': 'Master\'s Degree',
    'DE LICENCE': 'Bachelor\'s Degree',
    'LICENCE': 'Bachelor\'s Degree',
};

/** French document title (one line): thèse for doctorat, mémoire for HDR / Master / Licence */
const RAPPORT_TITLE_FR = {
    'DE DOCTORAT': 'Rapport de Soutenance de Thèse de Doctorat',
    'DE MÉMOIRE DE HDR': 'Rapport de Soutenance de Mémoire de HDR',
    'MÉMOIRE DE HDR': 'Rapport de Soutenance de Mémoire de HDR',
    'DE MASTER': 'Rapport de Soutenance de Mémoire de Master',
    'MASTER': 'Rapport de Soutenance de Mémoire de Master',
    'DE LICENCE': 'Rapport de Soutenance de Mémoire de Licence',
    'LICENCE': 'Rapport de Soutenance de Mémoire de Licence',
};

const RapportSoutenanceDocument = ({ formData, id, qrCodeData, lang }) => {
    const isEnglish = lang === 'english';
    const isFem = formData.genre === 'Madame';
    const g = (masc, fem) => (isFem ? fem : masc);
    const dateSoutenanceShort = formatDateShort(formData.dateSoutenance);
    const dateFaitLong = isEnglish ? formatDateWithMonthNameEnglish(formData.dateFait) : formatDateWithMonthName(formData.dateFait);
    const birthDateStr = formData.dateNaissance ? (isEnglish ? formatDateWithMonthNameEnglish(formData.dateNaissance) : formatDateWithMonthName(formData.dateNaissance)) : '—';
    const typeTravail = formData.typeTravail || 'sa thèse/son Mémoire';
    const juryList = formData.juryMembers && Array.isArray(formData.juryMembers) && formData.juryMembers.length > 0
        ? formData.juryMembers
        : [
            { role: 'Président', name: formData.juryPresident },
            { role: 'Directeur', name: formData.juryDirecteur },
            { role: 'Rapporteur', name: formData.juryRapporteur },
            { role: 'Membre', name: formData.juryMembre1 },
            { role: 'Membre', name: formData.juryMembre2 },
        ].map((m) => ({ ...m, name: m.name || '—' }));
    const roleLabel = (role) => (isEnglish ? (role === 'Président' ? 'Chair' : role === 'Directeur' ? 'Director' : role === 'Co-Directeur' ? 'Co-Director' : role === 'Rapporteur' ? 'Rapporteur' : 'Member') : role);

    /* Fixed signatures – same as Procès Verbal */
    const SIG_SECRETARY_TITLE = "Le Secrétaire du Jury";
    const SIG_SECRETARY_NAME = "Pr Ahyi Virgile / IRGIB Africa";
    const SIG_SECRETARY2_TITLE = "Le Secrétaire du Jury";
    const SIG_SECRETARY2_NAME = "NZEYIMANA Isaie / Université du Rwanda";
    const SIG_DIRECTOR_TITLE = "Le Directeur de l'Ecole Doctorale/UNCR University";
    const SIG_DIRECTOR_NAME = "Pr Jean Luc Perez";
    const SIG_DG_CIREP_TITLE = "Directeur Général du Cirep";
    const SIG_DG_CIREP_NAME = "NIZEYIMANA Jean-Baptiste";
    const SIG_RECTOR_TITLE = "Le Recteur de l'Université de Lisala";
    const SIG_RECTOR_NAME = "Pr Abbé TEBAKABE ALOMO Donat";
    /* English */
    const SIG_SECRETARY_TITLE_EN = "Jury Secretary";
    const SIG_SECRETARY_NAME_EN = "Pr Ahyi Virgile / IRGIB Africa";
    const SIG_SECRETARY2_TITLE_EN = "Jury Secretary";
    const SIG_SECRETARY2_NAME_EN = "NZEYIMANA Isaie / University of Rwanda";
    const SIG_DIRECTOR_TITLE_EN = "Director of the Doctoral School / UNCR University";
    const SIG_DG_CIREP_TITLE_EN = "General Director of Cirep";
    const SIG_RECTOR_TITLE_EN = "Rector of the University of Lisala";

    const v = (x) => (x ? <span className="pv-variable">{x}</span> : <span className="pv-variable">—</span>);

    const rapportTitleFr = RAPPORT_TITLE_FR[formData.titleType] || (formData.titleType ? `Rapport de Soutenance — ${formData.titleType}` : '—');

    return (
        <div id={`rapport-soutenance-${id}-${lang}`} className="attestation-validation-document proces-verbal-doc pv-page">
            <div className="attestation-validation-header">
                <div className="attestation-validation-header-row">
                    <div className="attestation-validation-left-logo">
                        <img src={unilislogo} alt="UNILIS" className="attestation-validation-logo" />
                        <div className="attestation-validation-left-text">
                            <h1 className="attestation-validation-school">{isEnglish ? 'DOCTORAL SCHOOL' : 'ECOLE DOCTORALE'}</h1>
                            <h2 className="attestation-validation-subtitle">{isEnglish ? 'International Joint Thesis and Co-diploma' : 'Cotutelle Internationale de Thèse et Co-diplomation'}</h2>
                        </div>
                    </div>
                    <div className="attestation-validation-header-center">
                        <h3 className="attestation-validation-university">UNIVERSITY OF LISALA</h3>
                        <p className="attestation-validation-center">{isEnglish ? 'Interuniversity Center for Multidisciplinary Research (Cirep)' : 'Centre Interuniversitaire de Recherche Pluridisciplinaire (Cirep)'}</p>
                        <p className="attestation-validation-status">Status: Public university</p>
                        <p className="attestation-validation-web">Web: www.universitedelisala.ac.cd</p>
                        <p className="attestation-validation-email">Email: info@universitedelisala.ad.cd</p>
                    </div>
                    <div className="attestation-validation-right-logo">
                        <img src={crlogo} alt="CRN" className="attestation-validation-logo" />
                    </div>
                </div>
            </div>
            <div className="attestation-validation-separator" />
            <div className="attestation-validation-title-section">
                {isEnglish ? (
                    <>
                        <h1 className="attestation-validation-main-title">DEFENSE REPORT</h1>
                        <h1 className="pv-title-sub">{TITLE_EN[formData.titleType] || formData.titleType || '—'}</h1>
                    </>
                ) : (
                    <h1 className="attestation-validation-main-title rapport-soutenance-title-fr">{rapportTitleFr}</h1>
                )}
            </div>
            <div className="pv-body attestation-validation-document-body">
                {isEnglish ? (
                    <>
                        <p className="pv-paragraph">
                            {formData.genre === 'Madame' ? 'Ms.' : 'Mr.'} {v(formData.candidateName)}, born on {v(birthDateStr)} in {v(formData.lieuNaissance)}, {v(formData.paysNaissance)}; registered at {v(formData.universite)} in joint supervision and co-diploma with UNCR University under number {v(formData.numeroInscription)} in {v(formData.domaine)}; Specialty: {v(formData.specialite)} defended {typeTravail} on {v(dateSoutenanceShort)} at {v(formData.universite)}.
                        </p>
                        <p className="pv-paragraph">In view of the favorable opinion of the Doctoral School in joint supervision and co-diploma with UNCR University and its Partner IRGIB Africa University attesting that the candidate has satisfied the competency checks provided by the legal and regulatory texts, the candidate defended before the jury below:</p>
                        <div className="pv-jury">
                            {juryList.map((member, i) => (
                                <p key={i}><strong>{roleLabel(member.role)}:</strong> {v(member.name)}</p>
                            ))}
                        </div>
                        <p className="pv-paragraph">The research work in joint thesis and co-diploma between the University of Lisala and UNCR University concerns the subject «{v(formData.sujetTravail)}».</p>
                        <p className="pv-paragraph">The jury, after having verified that the candidate had the required academic authorizations, gave {g('him', 'her')} fifteen minutes to present {g('his', 'her')} results.</p>
                        <p className="pv-paragraph">{formData.genre === 'Madame' ? 'Ms.' : 'Mr.'} {v(formData.candidateName)} presented {g('his', 'her')} work clearly. {g('He', 'She')} produced original scientific work of high quality despite some spelling errors. {g('His', 'Her')} thesis is well written with recent and quality bibliographic references. {g('He', 'She')} was able to answer the questions of the Jury members. The jury also noted an effort of harmonious layout facilitating the reading and understanding of the document.</p>
                        <p className="pv-paragraph">On the substance, the scientific work reflects in-depth, original and relevant research. The candidate addressed a current and crucial issue in the context of {g('his', 'her')} country. The scientific work is also distinguished by the quality of the proposals formulated, which can usefully inform public policies and the practices of actors in {g('his', 'her')} field.</p>
                        <p className="pv-paragraph">Following {g('his', 'her')} brilliant presentation and after deliberation, the jury decided unanimously to accept the research work of {formData.genre === 'Madame' ? 'Ms.' : 'Mr.'} {v(formData.candidateName)} with the distinction {v(formData.mention)}.</p>
                        <p className="pv-fait">Done at {v(formData.lieuFait)}, on {v(dateFaitLong)}</p>
                        <div className="pv-signatures">
                            <div className="pv-sig-row">
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_SECRETARY_TITLE_EN}</p><p className="pv-sig-name">{SIG_SECRETARY_NAME_EN}</p><img src={virgilSig} alt="" className="pv-sig-img" /></div>
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_SECRETARY2_TITLE_EN}</p><p className="pv-sig-name">{SIG_SECRETARY2_NAME_EN}</p><img src={papaSig} alt="" className="pv-sig-img" /></div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_DIRECTOR_TITLE_EN}</p><p className="pv-sig-name">{SIG_DIRECTOR_NAME}</p><img src={perezSig} alt="" className="pv-sig-img" /></div>
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_DG_CIREP_TITLE_EN}</p><p className="pv-sig-name">{SIG_DG_CIREP_NAME}</p><img src={bapSig} alt="" className="pv-sig-img" /></div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_RECTOR_TITLE_EN}</p><p className="pv-sig-name">{SIG_RECTOR_NAME}</p><img src={rectorSig} alt="" className="pv-sig-img" /></div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <p className="pv-paragraph">
                            {formData.genre === 'Madame' ? 'Madame' : 'Monsieur'} {v(formData.candidateName)}, {g('né', 'née')} le {v(birthDateStr)} à {v(formData.lieuNaissance)} au {v(formData.paysNaissance)} ; {g('inscrit', 'inscrite')} à {v(formData.universite)} en cotutelle et codiplomation avec l'UNCR University sous le numéro {v(formData.numeroInscription)} en {v(formData.domaine)} ; Spécialité : {v(formData.specialite)} a soutenu {typeTravail} en date du {v(dateSoutenanceShort)} à {v(formData.universite)}.
                        </p>
                        <p className="pv-paragraph">Vu l'avis favorable de l'Ecole Doctorale en cotutelle et codiplomation avec l'UNCR University et son Partenaire IRGIB Africa University attestant que {g("l'intéressé", "l'intéressée")} a satisfait au contrôle des compétences prévues par les textes légaux et réglementaires, {g("l'impétrant", "l'impétrante")} a soutenu devant le jury ci-après :</p>
                        <div className="pv-jury">
                            {juryList.map((member, i) => (
                                <p key={i}><strong>{member.role} :</strong> {v(member.name)}</p>
                            ))}
                        </div>
                        <p className="pv-paragraph">Le travail de recherche en cotutelle de thèse et Codiplomation entre l'université de Lisala et UNCR University porte sur le sujet <span id='sujet-travail'>{(formData.sujetTravail || '').trim().startsWith('«') ? formData.sujetTravail : `«${formData.sujetTravail}»`}</span>.</p>
                        <p className="pv-paragraph">Le jury, après avoir vérifié que {g('le candidat', 'la candidate')} avait les autorisations académiques requises, lui a donné quinze minutes pour présenter ses résultats.</p>
                        <p className="pv-paragraph">{formData.genre === 'Madame' ? 'Madame' : 'Monsieur'} {v(formData.candidateName)} a présenté ses travaux avec clarté. {g('Il', 'Elle')} a produit un travail scientifique original et de grande qualité malgré quelques fautes d'orthographe. {g('Son travail est bien rédigé', 'Son travail est bien rédigée')} avec les références bibliographiques récentes et de qualité. {g('Il', 'Elle')} a su répondre aux questions des membres du Jury. Le jury a noté également un effort de mise en page harmonieuse facilitant la lecture et la compréhension du document.</p>
                        <p className="pv-paragraph">Sur le fond, le travail scientifique témoigne d'un travail de recherche approfondi, original et pertinent. {g('Le candidat', 'La candidate')} a abordé une problématique actuelle et cruciale dans le contexte de son Pays. Le travail scientifique se distingue également par la qualité des propositions formulées, qui peuvent utilement nourrir les politiques publiques et les pratiques des acteurs de son domaine.</p>
                        <p className="pv-paragraph">A la suite de son brillant exposé et après en avoir délibéré, le jury a décidé à l'unanimité, d'accepter le travail de recherche de {formData.genre === 'Madame' ? 'Madame' : 'Monsieur'} {v(formData.candidateName)} avec la mention {v(formData.mention)}.</p>
                        <p className="pv-fait">Fait à {v(formData.lieuFait)}, le {v(dateFaitLong)}</p>
                        <div className="pv-signatures">
                            <div className="pv-sig-row">
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_SECRETARY_TITLE}</p><p className="pv-sig-name">{SIG_SECRETARY_NAME}</p><img src={virgilSig} alt="" className="pv-sig-img" /></div>
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_SECRETARY2_TITLE}</p><p className="pv-sig-name">{SIG_SECRETARY2_NAME}</p><img src={papaSig} alt="" className="pv-sig-img" /></div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_DIRECTOR_TITLE}</p><p className="pv-sig-name">{SIG_DIRECTOR_NAME}</p><img src={perezSig} alt="" className="pv-sig-img" /></div>
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_DG_CIREP_TITLE}</p><p className="pv-sig-name">{SIG_DG_CIREP_NAME}</p><img src={bapSig} alt="" className="pv-sig-img" /></div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block"><p className="pv-sig-title">{SIG_RECTOR_TITLE}</p><p className="pv-sig-name">{SIG_RECTOR_NAME}</p><img src={rectorSig} alt="" className="pv-sig-img" /></div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {qrCodeData && (
                <div className="pv-qr-container" aria-hidden="true">
                    <img src={qrCodeData} alt="QR Code" className="pv-qr-code" />
                </div>
            )}
        </div>
    );
};

export default RapportSoutenance;
